import { TApiParameter } from '../../../../../../api/endpoints/Parameter';
import { groupBy, map, orderBy } from 'lodash';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import * as React from 'react';
import { LeveledParam } from '../../../../../../entities/LeveledParam';

const styles = StyleSheet.create({
  root: {
  },
  group: {
    marginBottom: '2mm',
  },
  header: {
    marginRight: '1mm',
  },
  values: {
  }
})

const ParamLevelistFormatter = (props: {
  value: Array<LeveledParam>;
  params: {
    [shortname: string]: TApiParameter
  };
}) => {
  const { value, params } = props;

  const grouped = groupBy(value, 'param');

  return (
    <View style={styles.root}>
      {
        map(grouped, (group, shortname) => {
          const shortnameLowerCase = shortname.toLowerCase()
          const matchedParam = params[shortnameLowerCase];

          return (
            <View key={shortname} style={styles.group}>
              <Text style={styles.header}>
                {
                  matchedParam ?
                    `${matchedParam.name} (${shortnameLowerCase}):`
                    : `${shortnameLowerCase}:`
                }
              </Text>
              <Text style={styles.values}>
                {
                  orderBy(group, param => param.level)
                    .map(param => param.level).join(', ')
                }
              </Text>
            </View>
          )
        })}
    </View>
  )
}

export default ParamLevelistFormatter;
